// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"121":"73b9aa2580cb5403","539":"8797c007c67f05e0"}[chunkId] + ".js";
};